//processamento de manter dados de usuário no navegador, login e logout
//replica do aviso no arquivo de cookies: trocar para localStorage
import { cookies } from "@/pages/components/cookies";

const user = {
  setLogin(newLogin) {
    /* utilizada no componente-página de usuários
    o objetivo dessa função é atualizar o usuário para ser mostrado
    no menu visível ao clicar no sanduíche caso o usuário ativo troque
    seu login */
    this.LOGIN = newLogin;
    cookies.set("LOGIN", newLogin);
  },
  setPermission(newPermission) {
    /* utilizada no componente-página de usuários */
    this.PERMISSION = newPermission;
    cookies.set("PERMISSION", newPermission);
  },
  doLogin(data) {
    this.LOGIN = data.LOGIN; //
    this.ID = data.ID; //
    this.PERMISSION = data.PERMISSION; //
    this.HAS_MANAGEMENT_ACCESS = data.ADD_ONS_ACCESS.MANAGEMENT; //
    this.HAS_ALERTS_ACCESS = data.ADD_ONS_ACCESS.ALERTS; //
    cookies.set("authToken", data.token);
    cookies.set("LOGIN", data.LOGIN);
    cookies.set("ID", data.ID);
    cookies.set("PERMISSION", data.PERMISSION);
    cookies.set("GROUPNAME", data.GROUPNAME);
    cookies.set("HAS_MANAGEMENT_ACCESS", data.ADD_ONS_ACCESS.MANAGEMENT);
    cookies.set("HAS_ALERTS_ACCESS", data.ADD_ONS_ACCESS.ALERTS);
  },
  doLogout() {
    console.log("LOGOUT");
    cookies.del("authToken");
    cookies.del("LOGIN");
    cookies.del("ID");
    cookies.del("PERMISSION");
    cookies.del("GROUPNAME");
    cookies.del("HAS_MANAGEMENT_ACCESS");
    cookies.del("HAS_ALERTS_ACCESS");
    delete this.LOGIN; //
    delete this.ID; //
    delete this.PERMISSION; //
    delete this.HAS_MANAGEMENT_ACCESS; //
    delete this.HAS_ALERTS_ACCESS; //
    localStorage.removeItem("userData")
  },
  load() {
    let cookie = {
      LOGIN: cookies.get("LOGIN"),
      ID: cookies.get("ID"),
      PERMISSION: cookies.get("PERMISSION"),
      HAS_MANAGEMENT_ACCESS: cookies.get("HAS_MANAGEMENT_ACCESS"),
      HAS_ALERTS_ACCESS: cookies.get("HAS_ALERTS_ACCESS")
    };

    if (
      !(
        cookie.LOGIN ||
        cookie.ID ||
        cookie.PERMISSION ||
        cookies.get("authToken")
      )
    ) {
      this.doLogout();
      return false;
    } else {
      this.LOGIN = cookie.LOGIN;
      this.ID = cookie.ID;
      this.PERMISSION = cookie.PERMISSION;
      this.HAS_MANAGEMENT_ACCESS = cookie.HAS_MANAGEMENT_ACCESS;
      this.HAS_ALERTS_ACCESS = cookie.HAS_ALERTS_ACCESS;
      return true;
    }
  }
};

user.load();

export { user };
